<script>
  import { Carousel } from '@/scripts/vue/components/Carousel';
  import ProductFullscreenGallery from '@/scripts/vue/components/ProductFullscreenGallery';
  import CarouselLazyImage from '@/scripts/vue/components/CarouselLazyImage.vue';

  export default {
    components: {
      Carousel,
      ProductFullscreenGallery,
      CarouselLazyImage,
    },
    props: {
      items: {
        type: Array,
        default: () => ([]),
      },
      href: {
        type: String,
        default: null,
      },
      sizes: {
        type: Array,
        default: () => ([]),
      },
    },
    data() {
      return {
        carouselIndex: 0,
        isCarouselSliding: false,
        isShowFullscreenGallery: false,
      };
    },
    computed: {
      carouselItemsFirst() {
        return this.carouselItems.filter((item, i) => i === 0);
      },
      carouselItemsOthers() {
        return this.carouselItems.filter((item, i) => i > 0);
      },
      carouselItems() {
        return this.items.map((item) => item.preview);
      },
      fullscreenItems() {
        return this.items.map((item) => item.full);
      },
      isProductThumbs() {
        return this.href !== null && this.href !== undefined;
      },
    },
    methods: {
      carouselNext() {
        if (!this.$refs.carousel) return;
        this.$refs.carousel.next();
      },
      carouselPrev() {
        if (!this.$refs.carousel) return;
        this.$refs.carousel.prev();
      },
      carouselSlideTo(index) {
        if (!this.$refs.carousel) return;
        this.$refs.carousel.slideTo(index);
      },
      onCarouselSlideStart() {
        this.isCarouselSliding = true;
      },
      onCarouselSlideEnd() {
        this.isCarouselSliding = false;
      },
      onClickCarouselItem() {
        if (this.isProductThumbs) {
          window.location.href = this.href;
          return;
        }
        if (this.isCarouselSliding) return;
        this.isShowFullscreenGallery = true;
      },
    },
  };
</script>

<template>
  <div class="product-gallery">
    <Carousel
      v-if="!isProductThumbs"
      ref="carousel"
      v-model="carouselIndex"
      class="product-gallery__carousel"
      :loop="carouselItems.length > 1"
      @slide-start="onCarouselSlideStart"
      @slide-end="onCarouselSlideEnd"
    >
      <a
        v-for="(item, i) in carouselItems"
        :key="i"
        :href="item"
        class="product-gallery__carousel-item"
        @click.prevent="onClickCarouselItem"
      >
        <CarouselLazyImage
          class="product-gallery__carousel-image"
          :active="carouselIndex === i"
          :src="item"
          alt=""
        />
      </a>
    </Carousel>
    <Carousel
      v-else
      ref="carousel"
      v-model="carouselIndex"
      class="product-gallery__carousel"
      :loop="carouselItems.length > 1"
      @slide-start="onCarouselSlideStart"
      @slide-end="onCarouselSlideEnd"
    >
      <a
        v-for="(item, i) in carouselItemsFirst"
        :key="i"
        :href="item"
        class="product-gallery__carousel-item"
        @click.prevent="onClickCarouselItem"
      >
        <CarouselLazyImage
          class="product-gallery__carousel-image"
          :active="carouselIndex === i"
          :src="item"
          alt=""
        />
      </a>
      <div
        class="product-gallery__carousel-item"
        @click.prevent="onClickCarouselItem"
      >
        <div class="product-gallery__carousel-item__text">
          <span class="text-bold text-color-gray text-size-small"> Размеры в наличии: </span>
        </div>
        <div
          class="product-gallery__carousel-item__available-sizes"
        >
          <span
            v-for="(size, i) in sizes"
            :key="i"
            class="product-gallery__carousel-item__available-size"
          > {{ size }} </span>
        </div>
      </div>
      <a
        v-for="(item, i) in carouselItemsOthers"
        :key="i"
        :href="item"
        class="product-gallery__carousel-item"
        @click.prevent="onClickCarouselItem"
      >
        <CarouselLazyImage
          class="product-gallery__carousel-image"
          :active="carouselIndex === i"
          :src="item"
          alt=""
        />
      </a>
    </Carousel>
    <div
      v-if="isProductThumbs && carouselItems.length > 1"
    >
      <button
        type="button"
        class="product-gallery__control product-gallery__control_prev carousel__control carousel__control_prev"
        :class="{ '_stop': 0 === carouselIndex }"
        @click="carouselSlideTo(carouselIndex-1)"
      />
      <button
        type="button"
        class="product-gallery__control product-gallery__control_next carousel__control carousel__control_next"
        :class="{ '_stop': carouselIndex === carouselItems.length }"
        @click="carouselSlideTo(carouselIndex+1)"
      />
    </div>
    <div
      v-if="carouselItems.length > 1"
      class="product-gallery__dots"
    >
      <button
        v-for="(dot, i) in carouselItems"
        :key="i"
        type="button"
        class="product-gallery__dot"
        :class="{ '_active': i === carouselIndex }"
        @click="carouselSlideTo(i)"
      />
      <button
        v-if="isProductThumbs"
        type="button"
        class="product-gallery__dot"
        :class="{ '_active': carouselIndex === carouselItems.length }"
      />
    </div>
    <ProductFullscreenGallery
      :active="isShowFullscreenGallery"
      :items="fullscreenItems"
      @activate="isShowFullscreenGallery = true"
      @deactivate="isShowFullscreenGallery = false"
    />
  </div>
</template>

<style lang="scss" type="text/scss" scoped>
  .product-gallery {
    position: relative;

    &__carousel {
      position: relative;
      z-index: 80;
      height: 100%;

      & /deep/ > * {
        height: 100%;
        outline: none;
      }

      &-item {
        position: relative;
        display: block;
        cursor: pointer;
        height: 280px;

      }

      &-image {
        height: 100%;

        /deep/ img {
          position: relative;
          width: 100%;
          height: 100%;
          object-fit: contain;
          pointer-events: none;

          @include ie10-11 {
            @include centerer;
            height: 100%;
            width: auto;
          }
        }
      }
    }

    &__dots {
      margin-top: 5px;
      text-align: center;
    }

    &__control {
      z-index: 899;

      &_prev {
        left: 10px;
      }

      &_next {
        right: 10px;
      }

      &._stop {
        display: none;
      }
    }

    &__dot {
      @include reset-button;
      margin: 0 5px;
      padding: 0;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: $color-fill;

      &._active {
        background: $color-brand;
      }
    }
  }
</style>
